import React from 'react'
import PropTypes from 'prop-types'
import {
  ResultsWrapper,
  List,
  Instructions,
  AccessTokenList,
  AccessCodeResultWrapper,
  AccessCodeResultInnerWrapper,
} from './styles'

RosterResults.propTypes = {
  uploadResults: PropTypes.object.isRequired,
}
export default function RosterResults(props) {
  const { uploadResults } = props
  const { data } = uploadResults
  const hasErrors = data.errorSummary && !!data.errorSummary.length
  return (
    <ResultsWrapper hasErrors={hasErrors}>
      <React.Fragment>
        <span>{`${data.total} rows processed`}</span>
        <AccessCodeResultWrapper>
          {data &&
            Array.isArray(data.accessCodes) &&
            data.accessCodes.length > 0 && (
              <React.Fragment>
                <b>Created Access Codes</b>
                <AccessCodeResultInnerWrapper>
                  {data.accessCodes.map(({ siteId, nsCustomerId, accessCodes }) => {
                    const arrAccessCodes = Object.entries(accessCodes)
                    return (
                      arrAccessCodes.length > 0 && (
                        <AccessTokenList key={siteId}>
                          {nsCustomerId &&
                            <li>
                              NSCustomerId: {nsCustomerId}
                            </li>
                          }
                          <li>
                            {siteId && <li>
                                SiteId: {siteId}
                              </li>
                            }
                            <AccessTokenList>
                              {arrAccessCodes.map(([role, value]) => (
                                <li key={role}>
                                  {role}: {value}
                                </li>
                              ))}
                            </AccessTokenList>
                          </li>
                        </AccessTokenList>
                      )
                    )
                  })}
                </AccessCodeResultInnerWrapper>
              </React.Fragment>
            )}
        </AccessCodeResultWrapper>
        {hasErrors && (
          <Instructions>
            Please make changes to the following rows and re-upload
          </Instructions>
        )}
        {data.errorSummary.map((error, index) => (
          <div key={index}>
            <span>Error: {error.message}</span>
            <List>
              <li key="subId ">
                NsSubscriptionId: {error.record.nsSubscriptionId}
              </li>
              <li key="nsCustomerId ">
                NsCustomerId: {error.record.nsCustomerId}
              </li>
              <li key="sku ">Sku: {error.record.sku}</li>
              <li key="districtName ">
                DistrictName: {error.record.districtName}
              </li>
              <li key="externalSiteId ">
                ExternalSiteId: {error.record.externalSiteId}
              </li>
            </List>
          </div>
        ))}
      </React.Fragment>
    </ResultsWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/containers/css-admin/roster/RosterResults.js